export default __webpack_public_path__ + "static/media/MagneticHighlands60s.5d21149c.mp3";